export const FEATURE_KEYS = 'FEATURE_KEYS'
export const FAVORITE_EMOJIS = 'FAVORITE_EMOJIS'
export const THEME = 'THEME'
export const REMEMBER_MY_ACCOUNT = 'REMEMBER_MY_ACCOUNT'
export const CREATOR_PAGE_SIDER_COLLAPSED = 'CREATOR_PAGE_SIDER_COLLAPSED'
export const CREATOR_TAB = 'CREATOR_TAB'
